/**
 * LoggedOut Page - Shown after user logs out
 *
 * Version History:
 * v2.55 - 2026-02-04 - Migrated to Clerk authentication (navigate to /login)
 * v2.9 - 2026-01-24 - Initial implementation to handle back button after logout
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const LoggedOut: React.FC = () => {
  const navigate = useNavigate();

  // v2.55 - Navigate to Clerk login page
  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 2 }}>
          <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main', mb: 3 }} />
          <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main', mb: 2 }}>
            You've been logged out
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
            Thank you for using MyLojic. You can safely close this window or log in again.
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={handleLogin}
            sx={{
              bgcolor: 'accent.main',
              color: 'white',
              px: 6,
              py: 1.5,
              '&:hover': { bgcolor: 'accent.dark' }
            }}
          >
            Log In Again
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default LoggedOut;
